import { forEach } from "lodash";
import querystring from "querystring";

//API Paths
export const ENTITIES = "api/entities";

export const ENTITY_CONTACTS_GET = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/contacts`;
export const ENTITY_CONTACTS_CREATE = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/contacts`;
export const ENTITY_CONTACTS_UPDATE = (formId, entityId, contactId) => `api/forms/${formId}/entities/${entityId}/contacts/${contactId}`;
export const ENTITY_CONTACTS_DELETE = (formId, entityId, contactId) => `api/forms/${formId}/entities/${entityId}/contacts/${contactId}/delete`;
export const ENTITY_CONTACTS_RESTORE = (formId, entityId, contactId) => `api/forms/${formId}/entities/${entityId}/contacts/${contactId}/restore`;

export const FORM_ENTITY = (formId, entityId) => `api/forms/${formId}/entities/${entityId}`;
export const FORM_ENTITY_CREATE = (formId) => `api/forms/${formId}/entities`;
export const FORM_ENTITY_USERS = (formId, entityId) => `/api/forms/${formId}/entities/${entityId}/users`;
export const FORM_ENTITY_DETAILS = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/related`;
export const FORM_ENTITY_ASSOCIATION = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/related`;
export const FORM_ENTITY_IDENTIFIERS = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/identifiers`;
export const FORM_ENTITY_IDENTIFIERS_UPDATE = (formId, entityId, identifierId) => `api/forms/${formId}/entities/${entityId}/identifiers/${identifierId}`;
export const FORM_ENTITY_IDENTIFIER_ACTIVATE = (formId, entityId, identifierType, identifierValue) => {
	const encodedType = encodeURIComponent(identifierType);
	const encodedValue = encodeURIComponent(identifierValue);
	return `api/forms/${formId}/entities/${entityId}/identifiers/types/${encodedType}/${encodedValue}/activate`;
};
export const FORM_ENTITY_IDENTIFIER_DEACTIVATE = (formId, entityId, identifierType, identifierValue) => {
	const encodedType = encodeURIComponent(identifierType);
	const encodedValue = encodeURIComponent(identifierValue);
	return `api/forms/${formId}/entities/${entityId}/identifiers/types/${encodedType}/${encodedValue}/deactivate`;
};
export const FORM_ENTITY_CLASSIFICATIONS = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/classifications`;
export const FORM_ENTITY_CLASSIFICATION = (formId, entityId, classificationCode) => {
	const encoded = encodeURIComponent(classificationCode);
	return `api/forms/${formId}/entities/${entityId}/classifications/${encoded}`;
};
export const FORM_ENTITY_EFFECTIVE_RANGES = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/effective`;
export const FORM_ENTITY_EFFECTIVE_RANGE = (formId, entityId, id) => `api/forms/${formId}/entities/${entityId}/effective/${id}`;
export const FORM_ENTITIES_ASSIGNED = (formId) => `api/forms/${formId}/entities/assigned`;
export const FORM_ENTITY_NUMBERS = (formId, entityId) => `api/forms/${formId}/reports/entities/${entityId}/numbers`;
export const FORM_USERS_ENTITIES = (formId, userAccountId) => `api/forms/${formId}/users/${userAccountId}/entities`;
export const FORM_ENTITIES = (formId) => `/api/forms/${formId}/entities/by/query`;
export const FORM_ENTITY_TOKENS = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/tokens`;
export const FORM_TOKEN_DEACTIVATE = (formId, tokenId) => `api/forms/${formId}/tokens/${tokenId}/deactivate`;
export const FORM_ENTITY_INVENTORIES = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/inventory`;
export const FORM_ENTITY_INVENTORY_ITEM = (formId, entityId, itemId) => `api/forms/${formId}/entities/${entityId}/inventory/${itemId}`;
export const FORM_ENTITY_INVENTORY_SET = (formId, entityId, itemId) => `api/forms/${formId}/entities/${entityId}/inventory/${itemId}/set`;
export const FORM_ENTITY_INVENTORY_ATTEST = (formId, entityId, itemId) => `api/forms/${formId}/entities/${entityId}/inventory/${itemId}/attest`;
export const FORM_ENTITY_INVENTORY_RESET = (formId, entityId, itemId) => `api/forms/${formId}/entities/${entityId}/inventory/${itemId}/reset`;
export const FORM_ENTITY_BUSINESSES = (formId, entityId) => `api/forms/${formId}/entities/${entityId}/businesses`;
export const FORM_BUSINESS = (formId, businessId) => `api/forms/${formId}/businesses/${businessId}`;
export const FORM_BUSINESS_CHARGES = (formId, businessId, isAppliedToAllCurrentProducts) => 
	!isAppliedToAllCurrentProducts 
		? `api/forms/${formId}/businesses/${businessId}/fees` 
		: `api/forms/${formId}/businesses/${businessId}/fees?isAppliedToAllCurrentProducts=${isAppliedToAllCurrentProducts}`;
export const FORM_BUSINESS_PRODUCTS = (formId, businessId) => `api/forms/${formId}/businesses/${businessId}/products`;
export const BUSINESS_CUSTOMERS = (formId, businessId, entityId) => 
	entityId !== undefined 
	? `api/forms/${formId}/businesses/${businessId}/customers?entityId=${entityId}`
	: `api/forms/${formId}/businesses/${businessId}/customers`;
export const BUSINESS_CUSTOMER_TRANSACTIONS = (formId, businessId, customerId, { status } = {}) => 
	`api/forms/${formId}/businesses/${businessId}/customers/${customerId}/transactions${status !== undefined ? `?status=${status}` : ""}`;

export const FORM_EXPORT_REPORTS = (formId) => `api/forms/${formId}/exports/by/reports/`;
export const FORM_EXPORT_CONFIGS = (formId) => `api/forms/${formId}/exports/configurations`;
export const FORM_EXPORT_QUEUE_FOR_CONFIG = (formId, configCode) => `api/forms/${formId}/exports/configurations/${configCode}/queue`;
export const FORM_EXPORT_ENQUEUE = (formId, configCode) => `api/forms/${formId}/exports/configurations/${configCode}/enqueue`;
export const FORM_EXPORT_CREATE = (formId) => `api/forms/${formId}/exports`;
export const FORM_EXPORT_LOG_ID = (formId) => `api/forms/${formId}/export/logs/by/id`;
export const FORM_EXPORT_LOG_PAGE = (formId) => `api/forms/${formId}/export/logs/by/page`;
export const FORM_EXPORTS = (formId, configuration) => `api/forms/${formId}/exports/current?doNotLog=true&configuration=${configuration}`;
export const FORM_EXPORT_LOGS = (formId, exportLogId) => `api/forms/${formId}/export/logs/${exportLogId}`;

export const FORMS_REQUESTABLE = "api/forms?requestable=true";
export const FORMS_REQUEST = (formId, userId) => `api/forms/${formId}/users/${userId}/requests`;
export const FORMS_PROCESS_REQUEST = (formId, userId, requestId) => `api/forms/${formId}/users/${userId}/requests/${requestId}/process`;
export const FORMS_REJECT_REQUEST = (formId, userId, requestId) => `api/forms/${formId}/users/${userId}/requests/${requestId}/reject`;
export const FORMS_PENDING_REQUESTS = (formId, userId) => `api/forms/${formId}/users/${userId}/requests`;
export const FORM_CONFIG = (formId) => `api/forms/${formId}`;
export const FORM_REPORT = (formId, reportId) => `api/forms/${formId}/reports/${reportId}`;
export const FORM_REPORT_QUERY = (formId, params) => `api/forms/${formId}/reports?${querystring.stringify(params)}`;
export const FORM_REPORTS_BY_ID = (formId) => `api/forms/${formId}/reports/by/id`;
export const FORM_REPORTS_BATCH = (formId) => `api/forms/${formId}/reports/batch/get`;
export const FORM_REPORT_CREATE = (formId) => `api/forms/${formId}/reports`;
export const FORM_REPORT_UPDATE = (formId, reportId) => `api/forms/${formId}/reports/${reportId}`;
export const FORM_REPORT_DELETE = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/delete`;
export const FORM_REPORT_DETAILS = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/details`;
export const FORM_REPORT_SUBMIT = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/submit`;
export const FORM_REPORT_RESTORE = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/restore`;
export const FORM_REPORT_WITHDRAW = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/withdraw`;
export const FORM_REPORT_INVOICES = (formId, reportId, businessId, customerId) => 
	`api/forms/${formId}/reports/${reportId}/invoices?businessId=${businessId}${customerId !== undefined ? `&customerId=${customerId}` : ""}`;

export const FORM_PROXIES = (formId) => `api/forms/${formId}/proxies`;
export const FORM_PROXY_DETAILS = (formId, proxyId) => `api/forms/${formId}/proxies/${proxyId}`;
export const FORM_PROXY_EXECUTE = (formId, proxy, payloadObject) => {
	const baseUri = `api/forms/${formId}/proxies/${proxy.Code}`;

	if(proxy.Method !== "GET") {
		return baseUri;
	}

	const queryParams = [];

	forEach(payloadObject, (param, key) => {
		if(param !== null && param !== undefined) {
			queryParams.push(`${key}=${param}`);
		}
	});

	const qs = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

	return `${baseUri}${qs}`;
};

export const REPORT_DETAIL_DELETE = (formId, reportId, detailId) => `api/forms/${formId}/reports/${reportId}/details/${detailId}/delete/`;
export const REPORT_DETAIL_RESTORE = (formId, reportId, detailId) => `api/forms/${formId}/reports/${reportId}/details/${detailId}/restore/`;
export const FORM_REPORT_PREVIOUS = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/previous`;
export const FORM_REPORT_NEXT = (formId, reportId) => `api/forms/${formId}/reports/${reportId}/next`;

export const FORM_USERS = (formId) => `api/forms/${formId}/users`;
export const FORM_USER = (formId, subjectId) => `api/forms/${formId}/users/${subjectId}`;
export const FORM_USER_ROLES = (formId, subjectId) => `api/forms/${formId}/users/${subjectId}/roles`;
export const FORM_USER_FAVORITES = (formId, subjectId, entityId, targetType, relationshipType) => 
	`api/forms/${formId}/users/${subjectId}/favorite/entity/${entityId}?targetType=${targetType}&relationshipType=${relationshipType}`;

export const FORM_PERMISSIONS = (formId) => `api/forms/${formId}/security`;
export const FORM_NOTICES = (formId, isScoped = false) => `api/forms/${formId}/notices?isScoped=${isScoped}`;
export const FORM_NOTICE = (formId, noticeId) => `api/forms/${formId}/notices/${noticeId}`;
export const FORM_CAMPAIGNS = (formId) => `api/forms/${formId}/campaigns/current`;
export const FORM_CAMPAIGN = (formId, campaignId) => `api/forms/${formId}/campaigns/${campaignId}`;

export const ACCOUNT_NOTICE_READ = (noticeId) => `api/account/notices/${noticeId}/read`;
export const ACCOUNT_CAMPAIGN_INTERACT = (campaignId, versionId) => `api/account/campaigns/${campaignId}/versions/${versionId}/record`;
export const ACCOUNT_CAMPAIGN_INTERACTIONS = () => "api/account/campaigns/interactions";

export const PASSWORD_RESET = "api/account/password/reset";
export const INVITE_RESEND = "api/users/invite";

// export const USER_ENTITIES_ASSOCIATION = (userId, entityId) => `api/users/${userId}/entities/${entityId}`;
export const USER_PERMIT_ENTITY = (formId, userId, entityId, relationshipType, targetType) =>
	`api/forms/${formId}/users/${userId}/permit/entity/${entityId}?relationshipType=${relationshipType}&targetType=${targetType}`;
export const USER_REVOKE_ENTITY = (formId, userId, entityId, relationshipType, targetType) =>
	`api/forms/${formId}/users/${userId}/revoke/entity/${entityId}?relationshipType=${relationshipType}&targetType=${targetType}`;

export const TOKEN_STATUS = (token) => `api/authenticate/status?token=${token}`;
export const USER_IMPERSONATE = (userId) => `api/authenticate/impersonate/${userId}`;

export const FILE_FOR_FIELD = (formId, fieldId) => `api/forms/${formId}/fields/${fieldId}/files`;
export const FILE_COMMIT = (fileId) => `api/files/${fileId}/commit`;
export const REPORT_FILE_HANDLES = (formId, reportId, fileIds) => `api/forms/${formId}/reports/${reportId}/files?fileIds=${fileIds}`;

//Helper Functions
export const EXTRACT_PAGE_NAME = (route) => route.substr(route.indexOf(".") + 1);

//UI Routes
export const BASE_REPORT = "authenticated.report";
export const NEW_REPORT = "authenticated.report.create";
export const EDIT_REPORT = "authenticated.report.edit";
export const VIEW_REPORTS = "authenticated.view-reports";
export const DASHBOARD = "authenticated.dashboard";
export const ENTITIES_SCREEN = "authenticated.entities";
export const EXPORTS_SCREEN = "authenticated.exports";
export const USERS_SCREEN = "authenticated.users";
export const REPORTING_SCREEN = "authenticated.reporting";
export const ANALYTICS_SCREEN = "authenticated.analytics";
export const OPERATIONS_SCREEN = "authenticated.operations";
export const NOTICES_SCREEN = "authenticated.notices";
